export {default as EdAlert} from './EdAlert'
export {default as EdButton} from './EdButton'
export {default as EdForm} from './EdForm'
export {default as EdModal} from './EdModal'
export {default as EdInputText} from './EdInputText'
export {default as EdInputTextArea} from './EdInputTextArea'
export {default as EdInputSelectTipo} from './EdInputSelectTipo'
export {default as EdInputSelect} from './EdInputSelect'
export {default as EdInputSwitch} from './EdInputSwitch'
export {default as EdInputEditor} from './EdInputEditor'
export {default as EdInputDate} from './EdInputDate'
export {default as EdInputAutoComplete} from './EdInputAutoComplete'
export {default as EdInputUpload} from './EdInputUpload'
export {default as EdInputTime} from './EdInputTime'


// WEBPACK FOOTER //
// ./src/components/template/index.js